// The polite live region — what a screen reader is told, and when.
//
// A canvas is opaque to assistive tech, and no amount of markup makes a real-time herding game
// playable without sight. What IS achievable is that the state a sighted player reads off the
// paddock — which order is standing, how many are in, how it ended — is spoken rather than silent.
//
// **Meaningful changes only.** The HUD's clock updates sixty times a second; announcing it would
// make the live region unusable and drown the two events that matter. So this only speaks when
// something a player would notice actually changes.

export class Announcer {
  private last = ''

  constructor(private readonly el: HTMLElement) {}

  /** Speak, but never repeat — an unchanged message re-announced is noise. */
  say(message: string): void {
    if (message === this.last) return
    this.last = message
    this.el.textContent = message
  }
}

/** The sentence for a given run state. Pure, so what gets said is testable without a DOM. */
export function stateMessage(order: string | null, lifted: boolean, penned: number, total: number): string {
  const parts: string[] = []
  if (order) parts.push(lifted ? `${order}, holding` : order)
  parts.push(`${penned} of ${total} penned`)
  return parts.join('. ')
}
